export const SHORT_PREFERENCES_PATH = "/p";

function addOptionalSetupParams(params, { forceLive = false, accountId = "", selectedPlan = "" } = {}) {
  if (forceLive) {
    params.set("forceLive", "1");
  }
  if (String(accountId || "").trim()) {
    params.set("accountId", String(accountId || "").trim());
  }
  if (String(selectedPlan || "").trim()) {
    params.set("selectedPlan", String(selectedPlan || "").trim());
  }
}

export function buildExistingPreferencesPath({ forceLive = false, accountId = "", selectedPlan = "" } = {}) {
  const params = new URLSearchParams({
    step: "preferences",
    mode: "existing",
  });
  addOptionalSetupParams(params, { forceLive, accountId, selectedPlan });
  return `/setup?${params.toString()}`;
}

export function buildOnboardingPreferencesPath({ forceLive = false, accountId = "", selectedPlan = "" } = {}) {
  const params = new URLSearchParams({
    step: "preferences",
    mode: "new",
  });
  addOptionalSetupParams(params, { forceLive, accountId, selectedPlan });
  return `/setup?${params.toString()}`;
}

export function buildAuthenticatedPostLinkPreferencesPath({
  isRelink = false,
  forceLive = false,
  accountId = "",
  selectedPlan = "",
} = {}) {
  return isRelink
    ? buildExistingPreferencesPath({ forceLive, accountId })
    : buildOnboardingPreferencesPath({ forceLive, accountId, selectedPlan });
}

export function buildLinkedAuthPreferencesPath({
  setupMode = "",
  forceLive = false,
  accountId = "",
  selectedPlan = "",
} = {}) {
  return buildAuthenticatedPostLinkPreferencesPath({
    isRelink: String(setupMode || "").trim().toLowerCase() === "existing",
    forceLive,
    accountId,
    selectedPlan,
  });
}

export const EXISTING_PREFERENCES_PATH = buildExistingPreferencesPath();
export const ONBOARDING_PREFERENCES_PATH = buildOnboardingPreferencesPath();
